import { Coords } from '@energy-stacks/fleet/shared';
import { Box } from '@mui/material';
import { jobsMarkerStyles } from './jobsMarkerStyles';
import { DegassedJobIcon } from '../DegassedJobIcon';
import { RawJobIcon } from '../RawJobIcon';

type PoolJobMarkerProps = Coords & {
  productType: string;
  onClick?: () => void;
};

export const PoolJobMarker: React.FC<PoolJobMarkerProps> = ({
  productType,
  onClick,
}) => {
  return <PoolJobMarkerIcon productType={productType} onClick={onClick} />;
};

const PoolJobMarkerIcon = ({
  onClick,
  productType,
}: {
  onClick?: () => void;
  productType: string;
}) => {
  return (
    <Box onClick={onClick} sx={jobsMarkerStyles}>
      {productType === 'degassed' ? <DegassedJobIcon /> : <RawJobIcon />}
    </Box>
  );
};
